import React from 'react'
import styled from 'styled-components'

const IconDefinition = styled.i`
padding-right: 10px;
cursor: pointer;
`
IconDefinition.displayName = 'Icon'
export const Icon = IconDefinition

export const ChevronIcon = ({ direction }) => {
  return <Icon className={`fa fa-chevron-${direction}`} />
}

export const DetailChevron = ({ isOpen }) => {
  return <ChevronIcon direction={isOpen ? 'down' : 'right'} />
}

export const ListItemLabel = styled.span`
  color: ${props => props.theme.colors.primary};
  font-family: ${props => props.theme.fonts.Montserrat};
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.17px;
  line-height: 18px;
  width: 100%;
`

export const RemoveAction = styled.i.attrs(props => ({
  className: 'fa fa-trash-o'
}))`
  &.fa.fa-trash-o {
    cursor: pointer;
    font-size: 22px;
    color: ${props => props.theme.colors.blueGrey};
  }
`
